<template>
  <el-dialog
    title="展开属性"
    :visible.sync="dialogForm.visiable"
    class="middle-dialog"
    v-dialogDrag
    :close-on-click-modal="false"
    @open="openDialog"
  >
    <div class="flex">
      <el-select
        v-model="queryForm.classTypeId"
        size="small"
        clearable
        filterable
        placeholder="请选择类型"
      >
        <el-option
          v-for="(item, index) in classList"
          :key="index"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-input
        v-model="queryForm.classNameOrCode"
        size="small"
        clearable
        placeholder="请输入类别名称/代码"
        class="w-200px ml-10px mr-10px"
      ></el-input>
      <el-input
        v-model="queryForm.attributeNameOrCode"
        size="small"
        clearable
        placeholder="请输入属性名称/代码"
        class="w-200px"
      ></el-input>
      <el-select
        v-model="queryForm.isChoose"
        size="small"
        clearable
        filterable
        placeholder="请选择类型"
        class="ml-10px mr-10px"
      >
        <el-option label="未选" :value="0"></el-option>
        <el-option label="已选" :value="1"></el-option>
        <el-option label="全部" :value="2"></el-option>
      </el-select>
      <el-button type="primary" size="small" @click="searchTableData">搜索</el-button>
    </div>
    <el-table
      :data="tableData"
      stripe
      border
      v-loading="isLoadTable"
      height="300px"
      class="mt-10px"
      row-key="classAttributeId"
      @selection-change="handleSelectionChange"
      ref="table"
    >
      <el-table-column type="selection" width="55" reserve-selection></el-table-column>
      <el-table-column :label="$t('序号')" width="70" type="index"></el-table-column>
      <el-table-column label="实体类型" prop="classTypeName"></el-table-column>
      <el-table-column label="实体类别名称" prop="name"></el-table-column>
      <el-table-column label="属性分组" prop="attributeGroupName"></el-table-column>
      <el-table-column label="实体属性代码" prop="classAttributeCode"></el-table-column>
      <el-table-column label="实体属性名称" prop="classAttributeName"></el-table-column>
    </el-table>
    <div class="mt-10px">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page.pageNo"
        layout="->, total, sizes, prev, pager, next, jumper"
        :page-size.sync="page.pageSize"
        :total="page.total"
        :page-sizes="$pageSizeAll"
        :pager-count="5"
      >
      </el-pagination>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="save">保存</el-button>
      <el-button @click="dialogForm.visiable = false">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import EntityTypeService from '@/services/EntityTypeService'
import assetService from '@/services/assetService'

export default {
  name: 'ExpandProperties',
  props: {
    dialogForm: {
      type: Object,
    },
  },
  data() {
    return {
      queryForm: {
        classTypeId: '',
        classNameOrCode: '',
        attributeNameOrCode: '',
        isChoose: 0,
      },
      tableData: [],
      isLoadTable: false,
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      classList: [],
      selectionList: [],
    }
  },
  methods: {
    async openDialog() {
      this.queryForm = this.$options.data().queryForm
      await this.getClassList()
      this.searchTableData()
    },
    handleSelectionChange(val) {
      this.selectionList = val
    },
    save() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择数据')
        return
      }
      // 一个实体只能选择一个属性
      let flag = false
      _.map(this.selectionList, (item, index) => {
        _.map(this.selectionList, (item2, index2) => {
          if (index !== index2 && item.classId === item2.classId) {
            flag = true
          }
        })
      })
      if (flag) {
        this.$message.warning('一个实体只能选择一个属性')
        return
      }
      this.$emit('updateSelect', this.selectionList)
    },
    async searchTableData() {
      this.isLoadTable = true
      let choose
      if (this.queryForm.isChoose === 0) {
        choose = false // 未选
      } else if (this.queryForm.isChoose === 1) {
        choose = true // 已选
      } else {
        choose = null // 全部
      }
      const res = await assetService.getClassAndClassTypeAttrList({
        maxResultCount: this.page.pageSize,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        sorting: '',
        standardId: this.dialogForm.standardId,
        classTypeId: this.queryForm.classTypeId,
        classNameOrCode: this.queryForm.classNameOrCode,
        attributeNameOrCode: this.queryForm.attributeNameOrCode,
        isChoose: choose,
        ids: this.dialogForm.ids, // 数据id集合 传已选数据的id
      })
      this.isLoadTable = false
      if (res && res.code === 0 && res.data) {
        this.tableData = res.data
        this.page.total = res.totalCount
        this.selectionList = []
        if (this.$refs.table) {
          this.$refs.table.clearSelection()
        }
      }
    },
    handleCurrentChange(num) {
      this.page.pageNo = num
      this.searchTableData()
    },
    handleSizeChange(size) {
      this.page.pageSize = size
      this.searchTableData()
    },
    // 获取类型下拉列表数据
    async getClassList() {
      const params = {
        StandardId: this.dialogForm.standardId,
        SkipCount: 0,
        MaxResultCount: 1000,
      }
      const res = await EntityTypeService.getEntityTypeList(params)
      if (res && res.code === 0 && res.data) {
        this.classList = _.filter(res.data, (item) => {
          return item.approveStatus === 1
        })
      }
    },
  },
}
</script>
